export enum NotificationType {
	None = 0,
	Info = 1,
    Warn = 2,
    Error = 4,
    Critical = 8
}
